import React from 'react';
import SegmentPageTemplate from '../components/SegmentPageTemplate';
import segmentConfigs from '../config/segmentConfigs';

const LocacaoShopping = () => {
  return <SegmentPageTemplate {...segmentConfigs.shopping} />;
};

export default LocacaoShopping;